import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import BreadcrumbItem from "../../Components/common/Breadcrumb";
import {
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { useOidcUser } from "@axa-fr/react-oidc";
import { Link, useNavigate } from "react-router-dom";
import {
  carrierLogos,
  getAttachmentTypeLabel,
  getShipmentLabel,
  writeLabelAddress,
  useQuery,
  callErrorToast,
} from "../../utilities";
import ParcelsList from "./parcelsList";
import { ShipmentsService as ShipmentsShipmentService } from "../../services/shipment-service/shipments";
import CompaniesService from "../../services/registry-service/companies";
import ShipmentCostsService from "../../services/shipment-service/shipmentCosts";
import AttachmentsService from "../../services/registry-service/attachments";
import { CashOnDeliveryCollectionMethodsService } from "../../services/registry/cashOnDeliveryCollectionMethods";
import Delete from "./delete";
import Confirm from "./confirm";
import CreateEdit from "../Collections/CreateEdit";
import CustomDataPresentation from "./presentation/customDataPresentation";
import { CustomDataService } from "../../services/shipment/customData";
import ZPLViewer from "../../Components/common/ZPLViewer";
import { useAppContext } from "../../AppProvider";
import { useTypes } from "../../utilities/types";
import { HandlerStockReleaseShipmentProvider } from "../StockReleaseShipments/providers/Handler";
import { Handler as HandlerStockReleaseShipment } from "../StockReleaseShipments/Handler";
import { isDisabledStockRelease } from "./utilities/list";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGavel } from "../../utilities/fontawesomeIcons";
import { IndexStockReleaseShipmentsProvider } from "../StockReleaseShipments/providers/Index";
import StockReleaseShipments from "../StockReleaseShipments";
import { TrackingProvider } from "./providers/Tracking";
import Tracking from "./Tracking.tsx";
import { IndexEmailNotificationsProvider } from "../EmailNotifications/providers/Index.tsx";
import EmailNotifications from "../EmailNotifications/index.tsx";
import ButtonUtility from "../../Components/Buttons/Utility.tsx";
import { faEnvelope } from "@awesome.me/kit-c1b85ff10f/icons/classic/light";

const shipmentsShipmentService = new ShipmentsShipmentService();
const companiesRegistryService = new CompaniesService();
const shipmentCostsService = new ShipmentCostsService();
const attachmentsService = new AttachmentsService();
const cashOnDeliveryCollectionMethodsService =
  new CashOnDeliveryCollectionMethodsService();
const customDataService = new CustomDataService();

const modalSettingsDefault = {
  open: false,
  title: "",
  icon: "",
  action: "",
};

const DetailsShipment = () => {
  const { id } = useParams();
  const query = useQuery();
  //acr = ask collection reservetion
  let acr = query.get("acr");
  const { oidcUser } = useOidcUser();
  const [costsAndOptionsCollapse, setCostsAndOptionsCollapse] = useState(false);
  const [modalSettings, setModalSettings] = useState({ modalSettingsDefault });

  const [shipment, setShipment] = useState({});
  const [genericFields, setGenericFields] = useState([]);
  const [shipmentCosts, setShipmentCosts] = useState([]);
  const [shipmentOptions, setShipmentOptions] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [myCompanyGenericFields, setMyCompanyGenericFields] = useState([]);
  const [cashOnDeliveryCollectionMethod, setCashOnDeliveryCollectionMethod] =
    useState(null);
  const [customData, setCustomData] = useState([]);
  const [ddtEnabled, setDdtEnabled] = useState(true);

  const navigate = useNavigate();

  const { dictionary } = useAppContext();
  const { shipmentStatus } = useTypes();

  const getShipment = () => {
    shipmentsShipmentService
      .getShipment(id)
      .then((response) => {
        setShipment(response);
        if (response.id) {
          getAttachments(response.id);
        }
        if (response.cashOnDeliveryCollectionMethodCode) {
          getCashOndeLiveryCollectionMethod(
            response.cashOnDeliveryCollectionMethodCode
          );
        }
        if (
          response.contractService?.carrierService?.carrier
            .collectionCreationEnabled &&
          !response.collectionAssigned &&
          acr === "true" &&
          (response.status.code === "BOOKED" ||
            response.status.code === "CONFIRMED")
        ) {
          setModalSettings({
            ...modalSettings,
            title: dictionary.collections.do_you_want_to_book_a_collection,
            icon: "ph-calendar-check",
            open: !modalSettings.open,
            id,
            action: "createCollection",
          });
        }
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  const getCashOndeLiveryCollectionMethod = (code) => {
    cashOnDeliveryCollectionMethodsService
      .getCashOndeLiveryCollectionMethod(code)
      .then((response) => {
        if (response.status === 200) {
          setCashOnDeliveryCollectionMethod(response.data);
        }
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  const getCosts = () => {
    const filters = {
      search: {
        shipmentId: id,
      },
    };
    shipmentCostsService
      .getAll(filters)
      .then((response) => {
        setShipmentCosts(response.content || []);
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };
  const fetchCustomData = () => {
    const filters = {
      search: [
        {
          selector: "shipmentId",
          value: id,
          preciseSearch: true,
        },
      ],
    };
    customDataService
      .all(filters)
      .then((response) => {
        setCustomData(response.data.content || []);
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };
  const getAttachments = (shipmentId) => {
    const filters = {
      search: {
        shipmentId,
      },
    };
    attachmentsService
      .getAll(filters)
      .then((response) => {
        setAttachments(response.content || []);
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  const getOptions = () => {
    shipmentsShipmentService
      .getOptions(id)
      .then((response) => {
        setShipmentOptions(response || []);
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  const getGenericFields = () => {
    shipmentsShipmentService
      .getGenericFields(id)
      .then((response) => {
        setGenericFields(response);
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  const getMyCompanyGenericFields = () => {
    if (oidcUser) {
      companiesRegistryService
        .getGenericFields(oidcUser.owner)
        .then((response) => {
          setMyCompanyGenericFields(response || []);
        })
        .catch((err) => {
          callErrorToast(err, dictionary);
        });
    }
  };

  const modalToggle = () => {
    setModalSettings({ modalSettingsDefault, open: !modalSettings.open });
  };

  useEffect(() => {
    getShipment();
    getGenericFields();
    getCosts();
    getOptions();
    fetchCustomData();
  }, []);

  useEffect(() => {
    getMyCompanyGenericFields();
  }, [oidcUser]);

  return (
    <React.Fragment>
      {window.location.pathname === "/layout_no_header" ||
      window.location.pathname === "/layout_fixed_header" ? (
        ""
      ) : (
        <BreadcrumbItem
          title={dictionary.shipments.shipments}
          breadcrumbItem={dictionary.actions.details}
        />
      )}
      <div className="content" id="container">
        <div className="row">
          <div className="col">
            <Card className="">
              <CardHeader>
                <div className="row align-items-center">
                  <div className="col">
                    <div className="row">
                      <div className="col">
                        <label className="fw-semibold">
                          {dictionary.references.internal_reference}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>{shipment.internalReference}</label>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    <div className="row">
                      <div className="col">
                        <label className="fw-semibold">
                          {dictionary.references.waybill}
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label>{shipment.carrierReference || "-"}</label>
                      </div>
                    </div>
                  </div>
                  <div className="col">
                    {shipment.status && (
                      <div
                        style={{ backgroundColor: shipment.status.color }}
                        className={`status-container float-end`}
                      >
                        <span className={`status-name-small`}>
                          {
                            shipmentStatus.find(
                              (s) => shipment.status.code === s.value
                            ).label
                          }
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </CardHeader>
              <CardBody>
                <div className="row align-items-center">
                  {shipment.contractService?.id && (
                    <div className="col-5 text-center">
                      <img
                        className="mb-2"
                        width={75}
                        src={
                          carrierLogos[
                            shipment?.contractService?.carrierService.carrier
                              .code
                          ]
                        }
                      />
                      <span className="fs-sm text-muted fw-regular d-block">
                        {shipment?.contractService?.carrierService.name || "-"}
                      </span>
                    </div>
                  )}

                  <div className="col-4">
                    <div className="row">
                      <div className="col">
                        <span className="fw-semibold">
                          {/* {shipment.parcelType &&
                            parcels &&
                            `${parcels.length}x ${shipment.parcelType.name}`} */}
                          {dictionary.parcels.view_packages_2}{" "}
                          <i
                            className="ph-magnifying-glass cursor-pointer"
                            onClick={() =>
                              setModalSettings({
                                ...modalSettings,
                                title: dictionary.parcels.packages_2,
                                icon: "ph-package",
                                open: !modalSettings.open,
                                action: "parcels",
                              })
                            }
                          />
                        </span>
                      </div>
                      <div className="row mt-2">
                        <div className="col">
                          <label className="fw-semibold d-inline">
                            {dictionary.dimensions.total_weight}:
                          </label>{" "}
                          <label className="d-inline">
                            {shipment.weight && shipment.weight.toFixed(3)}kg
                          </label>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col">
                          <label className="fw-semibold d-inline">
                            {dictionary.dimensions.total_volume}:
                          </label>{" "}
                          <label className="d-inline">
                            {(shipment.volume && shipment.volume.toFixed(6)) ||
                              "-"}
                            &#13221;
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="row">
                      <div className="col text-center">
                        {shipment?.ratingCost && (
                          <div className="badge bg-success fs-4">
                            <span className="fs-2 d-block">
                              {shipment.ratingCost.toFixed(2)} €
                            </span>
                          </div>
                        )}
                        {shipment?.ratingTime > 0 && (
                          <div className="badge bg-info bg-opacity-20 text-info fs-4 mt-2">
                            <i className="ph-clock fs-4"></i>
                            <span className="" style={{ fontSize: "14px" }}>
                              {" "}
                              {shipment.ratingTime} {dictionary.times.hours}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col">
                    <label className="fw-semibold">
                      {dictionary.registries.pickup}:
                    </label>{" "}
                    <label>
                      {shipment.pickup &&
                        `${shipment.pickup.name} -
                        ${writeLabelAddress(shipment.pickup.location)}`}
                    </label>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col">
                    <label className="fw-semibold">
                      {dictionary.registries.receiver}:
                    </label>{" "}
                    <label>
                      {shipment.delivery &&
                        `${shipment.delivery.name} -
                        ${writeLabelAddress(shipment.delivery.location)}`}
                    </label>
                  </div>
                </div>
                {shipment.deliveryNote && (
                  <div className="row mt-1">
                    <div className="col">
                      <label className="fw-semibold">Note destinatario:</label>{" "}
                      <label>{shipment.deliveryNote}</label>
                    </div>
                  </div>
                )}
                <hr />
                <div className="row">
                  <div className="col">
                    <h6>{dictionary.words.general_informations}</h6>
                    <div className="row">
                      <div className="col">
                        <label className="fw-semibold">
                          {dictionary.shipments.shipment_typology}:
                        </label>{" "}
                        <label>{getShipmentLabel(shipment.shipmentType)}</label>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <label className="fw-semibold">
                          {dictionary.shipments.label_typology}:
                        </label>{" "}
                        <label>
                          {getAttachmentTypeLabel(shipment.labelTypeCode) ||
                            "-"}
                        </label>
                      </div>
                    </div>
                    {shipment.collection?.internalReference && (
                      <div className="row">
                        <div className="col">
                          <label className="fw-semibold d-block">
                            {dictionary.references.collection_reference}:
                          </label>{" "}
                          <Link
                            target="blank"
                            to={"../collections?id=" + shipment.collection.id}
                          >
                            {shipment.collection.internalReference}
                          </Link>
                        </div>
                      </div>
                    )}

                    {shipment.goodsValue && (
                      <div className="row">
                        <div className="col">
                          <label className="fw-semibold">
                            {dictionary.dimensions.goods_value}:
                          </label>{" "}
                          <label>
                            {shipment.goodsValue.toFixed(2)}{" "}
                            {shipment.goodsValueCurrency}
                          </label>
                        </div>
                      </div>
                    )}
                    {shipment.cashOnDeliveryValue && (
                      <div className="row">
                        <div className="col">
                          <label className="fw-semibold">
                            {dictionary.dimensions.cash_on_delivery_value}:
                          </label>{" "}
                          <label>
                            {shipment.cashOnDeliveryValue.toFixed(2)}{" "}
                            {shipment.cashOnDeliveryValueCurrency}
                          </label>
                        </div>
                      </div>
                    )}
                    {shipment.cashOnDeliveryValue &&
                      cashOnDeliveryCollectionMethod && (
                        <div className="row">
                          <div className="col">
                            <label className="fw-semibold">
                              {dictionary.words.cash_on_delivery_method}:
                            </label>{" "}
                            <label>{cashOnDeliveryCollectionMethod.name}</label>
                          </div>
                        </div>
                      )}
                    {shipment.insuranceValue && (
                      <div className="row">
                        <div className="col">
                          <label className="fw-semibold">
                            {dictionary.dimensions.insurance_value}:
                          </label>{" "}
                          <label>
                            {shipment.insuranceValue.toFixed(2)}{" "}
                            {shipment.insuranceValueCurrency}
                          </label>
                        </div>
                      </div>
                    )}
                    {shipment.ddtNumber && (
                      <div className="row">
                        <div className="col">
                          <label className="fw-semibold">
                            {dictionary.references.ddt_number}:
                          </label>{" "}
                          <label>{shipment.ddtNumber}</label>
                        </div>
                      </div>
                    )}
                    {customData?.length > 0 && (
                      <CustomDataPresentation customData={customData} />
                    )}
                  </div>
                  <div className="col">
                    <h6>{dictionary.words.additional_fields}</h6>
                    {/* {genericFields.length > 0 &&
                      genericFields.map((elem, index) => {
                        var labelCounter = 0;
                        return (
                          <div className="row" key={index}>
                            <div className="col">
                              {myCompanyGenericFields &&
                                myCompanyGenericFields.map((elem2, index2) => {
                                  if (elem2.rank == elem.rank) {
                                    labelCounter = 1;
                                    return (
                                      <label
                                        className="fw-semibold"
                                        key={index2}
                                      >
                                        {elem2.value}:
                                      </label>
                                    );
                                  }
                                  return "";
                                })}
                              {labelCounter === 0 && (
                                <label className="fw-semibold">
                                  {`Campo aggiuntivo ${index + 1}`}:
                                </label>
                              )}{" "}
                              <label>{elem.value || "-"}</label>
                            </div>
                          </div>
                        );
                      })} */}
                    {shipment.externalReference && (
                      <div className="row">
                        <div className="col">
                          <label className="fw-semibold">
                            {dictionary.references.external_reference}:
                          </label>{" "}
                          <label>{shipment.externalReference}</label>
                        </div>
                      </div>
                    )}
                    {shipment.content && (
                      <div className="row">
                        <div className="col">
                          <label className="fw-semibold">
                            {dictionary.words.content}:
                          </label>{" "}
                          <label>{shipment.content}</label>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label className="fw-semibold">
                      {dictionary.words.note}:
                    </label>{" "}
                    <label>{shipment.note}</label>
                  </div>
                </div>
                {shipment && (
                  <React.Fragment>
                    <div
                      className="row mt-3 accordion"
                      id="costsAndOptionsAccordion"
                    >
                      <div className="col text-center">
                        <Link
                          to="#"
                          color="primary"
                          type="button"
                          onClick={() =>
                            setCostsAndOptionsCollapse(!costsAndOptionsCollapse)
                          }
                          style={{ cursor: "pointer", fontSize: "1rem" }}
                          className="mb-2"
                        >
                          {dictionary.words.costs} {dictionary.words.and}{" "}
                          {dictionary.words.options}
                        </Link>
                      </div>

                      <Collapse
                        isOpen={costsAndOptionsCollapse}
                        className="accordion-collapse"
                      >
                        <div className="row justify-content-center mt-4">
                          <div className="col">
                            <h6>{dictionary.words.costs}</h6>
                            {shipmentCosts.length > 0 ? (
                              shipmentCosts.map((elem, index) => {
                                let valueLabel;
                                if (elem.value === 0) {
                                  valueLabel = (
                                    <label className="text-success">
                                      {dictionary.words.free}
                                    </label>
                                  );
                                } else if (elem.value === null) {
                                  valueLabel = (
                                    <label className="text-danger">
                                      {dictionary.status.not_available}
                                    </label>
                                  );
                                } else {
                                  let time =
                                    elem.time > 0 ? `/ ${elem.time} ore` : "";
                                  valueLabel = (
                                    <label>
                                      {elem.value.toFixed(2)}€ {time}
                                    </label>
                                  );
                                }
                                return (
                                  <div key={index} className="row">
                                    <div className="col">
                                      <label className="fw-semibold">
                                        {elem.name}:{" "}
                                      </label>{" "}
                                      {""}
                                      {valueLabel}
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <label>
                                {dictionary.messages.no_results_found}
                              </label>
                            )}
                          </div>
                          <div className="col">
                            <h6>{dictionary.words.options}</h6>
                            {shipmentOptions.length > 0 ? (
                              shipmentOptions.map((elem, index) => {
                                return (
                                  <div key={index} className="row">
                                    <div className="col">
                                      <label className="fw-semibold">
                                        {elem.surcharge.name}
                                      </label>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <label>
                                {dictionary.messages.no_results_found}
                              </label>
                            )}
                          </div>
                        </div>
                      </Collapse>
                    </div>
                    <div className="row">
                      <div className="col"></div>
                    </div>
                  </React.Fragment>
                )}
              </CardBody>
            </Card>
          </div>
          <div className="col">
            <TrackingProvider shipment={shipment}>
              <Tracking />
            </TrackingProvider>
            <div className="col">
              <div className="row">
                <div className="col">
                  <Card>
                    <CardHeader>
                      <div className="row">
                        <div className="col">
                          <h5 className="m-0">
                            {dictionary.words.labels} {dictionary.words.and}{" "}
                            {dictionary.words.documents}
                          </h5>
                        </div>
                        <div className="col text-end">
                          {shipment?.orderId && (
                            <Link
                              color="light"
                              className="btn btn-outline-success btn-sm"
                              to={"/shipments/ddt/" + id + "/print"}
                              target="blank"
                            >
                              {dictionary.actions.print} DDT{" "}
                              <i className="ph-download ms-2"></i>
                            </Link>
                          )}
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <div className="row">
                        {attachments.length > 0 ? (
                          attachments.map((elem, index) => {
                            return (
                              <div
                                key={index}
                                className={`${
                                  attachments.length === 1 ? "col" : "col-6"
                                } mt-3`}
                              >
                                <iframe
                                  className="w-100"
                                  height={`${
                                    attachments.length === 1 ? 300 : null
                                  }`}
                                  src={elem.url}
                                ></iframe>
                                <div className="row mt-3">
                                  <div className="col text-center">
                                    <Link
                                      color="light"
                                      className="btn btn-outline-success btn-sm"
                                      to={elem.url}
                                      target="blank"
                                    >
                                      {dictionary.actions.download}{" "}
                                      <i className="ph-download ms-2"></i>
                                    </Link>
                                    {elem.type.format === "ZPL" && (
                                      <>
                                        <button
                                          type="button"
                                          className="btn btn-light btn-sm ms-2"
                                          title={
                                            dictionary.labels.zpl_label_in_pdf
                                          }
                                          onClick={() =>
                                            setModalSettings({
                                              ...modalSettings,
                                              title:
                                                dictionary.labels
                                                  .zpl_label_in_pdf,
                                              icon: "ph-file-pdf",
                                              open: !modalSettings.open,
                                              url: elem.url,
                                              action: "zpl",
                                            })
                                          }
                                        >
                                          <i className="ph-file-pdf"></i>
                                        </button>
                                        <label className="form-check d-inline-block mb-2 ms-2">
                                          <input
                                            name="priv"
                                            type="checkbox"
                                            className="form-check-input form-check-input-success"
                                            value={ddtEnabled}
                                            checked={ddtEnabled}
                                            onChange={() => {
                                              setDdtEnabled(!ddtEnabled);
                                            }}
                                          />
                                          <span className="form-check-label">
                                            Aggiungi DDT in etichetta
                                          </span>
                                        </label>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <label className="text-center">
                            {dictionary.messages.no_results_found}
                          </label>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
              <div className="row"></div>
            </div>
          </div>

          {/* <div className={`${attachments.length > 0 ? "col-12 mt-3" : "col"}`}>
            <Card>
              <div className="accordion" id="accordion">
                <h5 className="accordion-header" id="headingOne">
                  <Link
                    to="#"
                    color="primary"
                    className={classnames("accordion-button", "fw-medium", {
                      collapsed: !trackingCollapse,
                    })}
                    type="button"
                    onClick={() => setTrackingCollapse(!trackingCollapse)}
                    style={{ cursor: "pointer", fontSize: "1.125rem" }}
                  >
                    Tracking
                  </Link>
                </h5>
                <Collapse
                  isOpen={trackingCollapse}
                  className="accordion-collapse"
                >
                  <div className="accordion-body">
                    <div className="row justify-content-center">
                      <div className="col-8">
                        <Tracking data={shipmentEvents} />
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>
            </Card>
          </div> */}
        </div>

        <div className="row mt-3">
          <div className="col-3 text-start">
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => {
                navigate(`/shipments`);
              }}
            >
              <i className="ph-arrow-left ph-sm me-2"></i>
              {dictionary.words.back}
            </button>
          </div>
          <div className="col text-end">
            {!isDisabledStockRelease([shipment]) && (
              <button
                type="button"
                className="btn btn-light btn-sm me-2"
                onClick={() =>
                  setModalSettings({
                    ...modalSettings,
                    open: !modalSettings.open,
                    action: "createStockRelease",
                  })
                }
              >
                <FontAwesomeIcon icon={faGavel} className="me-1" />
                {dictionary.shipments.stock_release}
              </button>
            )}
            {shipment?.statusType === "TRACKING" && (
              <button
                type="button"
                className="btn btn-light btn-sm me-2"
                onClick={() =>
                  setModalSettings({
                    ...modalSettings,
                    open: !modalSettings.open,
                    action: "emailNotifications",
                    data: shipment?.internalReference,
                  })
                }
              >
                <FontAwesomeIcon icon={faEnvelope} className="me-1" />
                {dictionary.notifications.email_notifications}
              </button>
            )}
            <button
              type="button"
              className="btn btn-outline-primary btn-sm me-2"
              onClick={() => {
                navigate(`/shipments/clone/${id}`);
              }}
            >
              <i className="ph-users ph-sm me-2"></i>{" "}
              {dictionary.actions.duplicate}
            </button>
            {(shipment.status?.code === "BOOKED" ||
              shipment.status?.code === "DRAFT") && (
              <button
                type="button"
                className="btn btn-outline-danger btn-sm me-2"
                onClick={() =>
                  setModalSettings({
                    ...modalSettings,
                    title: dictionary.actions.delete,
                    icon: "ph-trash",
                    open: !modalSettings.open,
                    id,
                    action: "delete",
                  })
                }
              >
                <i className="ph-trash ph-sm me-2"></i>
                {dictionary.actions.delete}
              </button>
            )}
            {shipment.status?.code === "DRAFT" && (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => {
                    navigate(`/shipments/edit/${id}`);
                  }}
                >
                  <i className="ph-note-pencil ph-sm me-2"></i>
                  {dictionary.actions.edit}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-success btn-sm"
                  onClick={() => {
                    navigate(`/shipments/rate/${id}`);
                  }}
                >
                  <i className="ph-note-pencil ph-sm me-2"></i>
                  {dictionary.rating.choose_rate}
                </button>
              </React.Fragment>
            )}

            {shipment.status?.code === "BOOKED" && (
              <button
                type="button"
                className="btn btn-light btn-sm me-2"
                onClick={() =>
                  setModalSettings({
                    ...modalSettings,
                    title: dictionary.actions.confirm,
                    icon: "ph-check",
                    open: !modalSettings.open,
                    id: id,
                    action: "confirm",
                  })
                }
              >
                <i className="ph-check ph-sm me-2"></i>
                {dictionary.actions.confirm}
              </button>
            )}
            {(shipment.status?.code === "BOOKED" ||
              shipment.status?.code === "CONFIRMED") &&
              !shipment.collectionAssigned &&
              shipment.contractService.carrierService.carrier
                .collectionCreationEnabled && (
                <button
                  type="button"
                  className="btn btn-light btn-sm me-2 "
                  onClick={() => {
                    setModalSettings({
                      ...modalSettings,
                      title:
                        dictionary.collections.do_you_want_to_book_a_collection,
                      icon: "ph-calendar-check",
                      open: !modalSettings.open,
                      id,
                      action: "createCollection",
                    });
                  }}
                >
                  <i className="ph-calendar-check ph-sm me-2"></i>
                  {dictionary.collections.do_you_want_to_book_a_collection}
                </button>
              )}
          </div>
        </div>
      </div>

      <Modal
        isOpen={modalSettings.open}
        className={`modal-content ${modalSettings.className || ""}`}
        size={modalSettings.size || "lg"}
        style={modalSettings.size === "xxl" ? { minWidth: "90%" } : {}}
      >
        <ModalHeader toggle={modalToggle}>
          <span className="modal-title">
            <i className={modalSettings.icon + " me-2"}></i>
            {modalSettings.title}
          </span>
        </ModalHeader>
        <ModalBody className={`${modalSettings.className || ""}`}>
          {modalSettings.action === "parcels" && (
            <ParcelsList shipmentId={shipment.id} />
          )}
          {modalSettings.action === "emailNotifications" && (
            <IndexEmailNotificationsProvider
              parentId={modalSettings.data}
              action="details"
              callback={() => {
                getShipment();
                modalToggle();
              }}
            >
              <h3 className=" text-center">{modalSettings.title}</h3>
              <EmailNotifications />
              <ButtonUtility
                className="mt-2"
                onClick={() => {
                  getShipment();
                  modalToggle();
                }}
              >
                {dictionary.actions.cancel}
              </ButtonUtility>
              <div></div>
            </IndexEmailNotificationsProvider>
          )}
          {modalSettings.action === "delete" && (
            <Delete
              id={id}
              callback={(success) => {
                if (success) {
                  navigate(`/shipments`);
                  return false;
                }
                modalToggle();
              }}
            />
          )}
          {modalSettings.action == "confirm" && (
            <Confirm
              id={modalSettings.id}
              callback={(success) => {
                if (success) {
                  navigate(`/shipments`);
                  return false;
                }
                modalToggle();
              }}
            />
          )}
          {modalSettings.action == "createCollection" && (
            <CreateEdit
              userOwnerId={oidcUser?.owner}
              defaultContactId={shipment.pickup.id}
              shipmentIds={[shipment.id]}
              carrierCode={shipment.contractService.carrierService.carrier.code}
              unmountCallback={() => {
                acr = "false";
                getShipment();
                modalToggle();
              }}
            />
          )}
          {modalSettings.action == "zpl" && (
            <ZPLViewer
              reference={
                shipment.carrierReference || shipment.internalReference
              }
              url={modalSettings.url}
              callback={() => {
                modalToggle();
              }}
              ddtEnabled={ddtEnabled}
              shipmentId={shipment.id}
            />
          )}
          {modalSettings.action == "createStockRelease" && (
            <HandlerStockReleaseShipmentProvider
              event={{
                shipmentId: shipment.id,
                deliveryId: shipment.delivery?.id,
                carrierCode:
                  shipment.contractService.carrierService.carrier.code,
                internalReference: shipment.internalReference,
                carrierReference: shipment.carrierReference,
                note: shipment.statusEventNote,
                utc: true,
              }}
              callback={() => {
                getShipment();
                modalToggle();
              }}
              action="create"
            >
              <HandlerStockReleaseShipment />
            </HandlerStockReleaseShipmentProvider>
          )}
          {/* {modalSettings.action === "customsData" && (
            <ParcelsList data={shipment.customsData} />
          )} */}
          {modalSettings.action == "stockReleasesShipment" && (
            <IndexStockReleaseShipmentsProvider
              parentId={shipment.internalReference}
            >
              <StockReleaseShipments />
            </IndexStockReleaseShipmentsProvider>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default DetailsShipment;
